import { type ReactNode } from 'react';
import { BonusHistoryModal } from './bonus-history-modal';
import { useCycleTotals, type CycleTotal } from '../hooks/use-cycle-totals';
import { InvestmentHistoryRow } from './investment-history-row';

type Props = { open: boolean; onClose: () => void };

const TH =
  'pb-3 text-left text-[10px] font-medium uppercase tracking-wider text-text-tertiary/60';

function Table({ cycles }: { cycles: CycleTotal[] }): ReactNode {
  return (
    <table className="w-full min-w-[28rem] text-left">
      <thead>
        <tr>
          <th className={TH}>Semana</th>
          <th className={TH}>Collectors</th>
          <th className={TH}>Total</th>
          <th className={TH}></th>
        </tr>
      </thead>
      <tbody>
        {cycles.map((c) => (
          <InvestmentHistoryRow key={c.period_start} c={c} />
        ))}
      </tbody>
    </table>
  );
}

export function InvestmentHistoryModal(p: Props): ReactNode {
  const { data, isLoading } = useCycleTotals(p.open);
  const cycles = data?.cycles ?? [];
  return (
    <BonusHistoryModal
      open={p.open}
      onClose={p.onClose}
      title="Inversión por ciclo"
      loading={isLoading}
      empty={!isLoading && cycles.length === 0}
      emptyLabel="Aún no hay ciclos cerrados"
    >
      <Table cycles={cycles} />
    </BonusHistoryModal>
  );
}
